import { render, staticRenderFns } from "./files-updown-android.vue?vue&type=template&id=27820fc3&scoped=true&"
import script from "./files-updown-android.vue?vue&type=script&lang=ts&"
export * from "./files-updown-android.vue?vue&type=script&lang=ts&"
import style0 from "./files-updown-android.vue?vue&type=style&index=0&id=27820fc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27820fc3",
  null
  
)

export default component.exports